import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaStore, FaCheckCircle, FaBook, FaStar, FaHeadset, FaShoppingCart } from 'react-icons/fa';
import { getCart } from '../../services/api';
import './Navbar.css';

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [cartCount, setCartCount] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    // Initialize cart count
    updateCartCount();

    // Listen for cart updates
    const handleCartUpdate = () => {
      updateCartCount();
    };

    window.addEventListener('cartUpdated', handleCartUpdate);
    return () => window.removeEventListener('cartUpdated', handleCartUpdate);
  }, []);

  const updateCartCount = () => {
    const cart = getCart();
    const totalItems = cart.reduce((sum, item) => sum + item.quantity, 0);
    setCartCount(totalItems);
  };

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const scrollToFooter = (e) => {
    e.preventDefault();
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: 'smooth'
    });
    setIsOpen(false);
  };

  const handleCartClick = () => {
    navigate('/cart');
    setIsOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="container navbar-container">
        {/* Logo - Far Left */}
        <Link to="/" className="navbar-logo">
          <img src="/logo.png" alt="RiftOne" className="logo-image" />
        </Link>

        {/* Desktop Menu */}
        <div className="navbar-menu">
          <div className="navbar-left">
            <Link to="/products" className="navbar-link">
              <FaStore className="navbar-link-icon" />
              <span>Store</span>
            </Link>
            <Link to="/status" className="navbar-link">
              <FaCheckCircle className="navbar-link-icon" />
              <span>Status</span>
            </Link>
            <span className="navbar-link disabled" title="Coming Soon">
              <FaBook className="navbar-link-icon" />
              <span>Guides</span>
            </span>
            <Link to="/reviews" className="navbar-link">
              <FaStar className="navbar-link-icon" />
              <span>Reviews</span>
            </Link>
          </div>

          <div className="navbar-right">
            <a href="#footer" onClick={scrollToFooter} className="navbar-link">
              <FaHeadset className="navbar-link-icon" />
              <span>Support</span>
            </a>
            <button className="cart-button" onClick={handleCartClick}>
              <FaShoppingCart />
              <span>Cart</span>
              {cartCount > 0 && <span className="cart-count">{cartCount}</span>}
            </button>
          </div>
        </div>

        {/* Mobile Toggle */}
        <button className="navbar-toggle" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* Mobile Menu */}
        <div className={`navbar-menu-mobile ${isOpen ? 'active' : ''}`}>
          <Link to="/products" className="navbar-link" onClick={() => setIsOpen(false)}>
            <FaStore className="navbar-link-icon" />
            <span>Store</span>
          </Link>
          <Link to="/status" className="navbar-link" onClick={() => setIsOpen(false)}>
            <FaCheckCircle className="navbar-link-icon" />
            <span>Status</span>
          </Link>
          <span className="navbar-link disabled" title="Coming Soon">
            <FaBook className="navbar-link-icon" />
            <span>Guides</span>
          </span>
          <Link to="/reviews" className="navbar-link" onClick={() => setIsOpen(false)}>
            <FaStar className="navbar-link-icon" />
            <span>Reviews</span>
          </Link>
          <a href="#footer" onClick={scrollToFooter} className="navbar-link">
            <FaHeadset className="navbar-link-icon" />
            <span>Support</span>
          </a>
          <button className="cart-button" onClick={handleCartClick}>
            <FaShoppingCart />
            <span>Cart</span>
            {cartCount > 0 && <span className="cart-count">{cartCount}</span>}
          </button>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
